const rawApiBaseUrl =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

const apiBaseUrl = rawApiBaseUrl.trim().replace(/\/+$/, "") || window.location.origin;

export const saveContactMessage = async ({ name, email, message }) => {
  const record = {
    name: name.trim(),
    email: email.trim().toLowerCase(),
    message: message.trim(),
  };

  const response = await fetch(`${apiBaseUrl}/api/contact`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(record),
  });
  const payload = await response.json().catch(() => null);

  if (!response.ok || payload?.status === "error") {
    throw new Error(payload?.message || "Unable to save your message.");
  }
};
